var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fy_index_title"},_vm._l((_vm.titleList),function(title){return _c('div',[_c('h2',[_vm._v(_vm._s(title[0]))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(title[1]))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-350d8374","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fy_index_title.vue
// module id = null
// module chunks = 